/**
 * Team members who can be assigned as sale owners on campaigns.
 * Add new members here - TypeScript will enforce adding their IDs below.
 */
export type SaleOwnerName = "Felix" | "Ariel" | "Fares" | "Dima" | "Tom" | "Ivan" | "Gabriel" | "Mathieu" | "Leandro";

export type SaleOwner = {
  name: SaleOwnerName;
  discordId: string;
  hubspotOwnerId?: string;
};

/**
 * Sale owners with their Discord IDs and HubSpot owner IDs.
 *
 * Discord IDs are used as the saleOwner field value in campaigns.
 * HubSpot owner IDs are found in: Settings > Users & Teams > click user > ID in URL
 * Or via API: GET /crm/v3/owners
 */
export const SALE_OWNERS: Record<SaleOwnerName, SaleOwner> = {
  Felix: {
    name: "Felix",
    discordId: "1190243872782155807",
    hubspotOwnerId: "82339192",
  },
  Ariel: {
    name: "Ariel",
    discordId: "964811050430128161",
    hubspotOwnerId: "82339301",
  },
  Fares: {
    name: "Fares",
    discordId: "971072333802532894",
    hubspotOwnerId: "83438868",
  },
  Dima: {
    name: "Dima",
    discordId: "494506746061127689",
    hubspotOwnerId: "82339260",
  },
  Tom: {
    name: "Tom",
    discordId: "656875153313235004",
    hubspotOwnerId: "84993402",
  },
  Ivan: {
    name: "Ivan",
    discordId: "251331673218613248",
    hubspotOwnerId: "86864971",
  },
  Gabriel: {
    name: "Gabriel",
    discordId: "527632262502547487",
  },
  Mathieu: {
    name: "Mathieu",
    discordId: "239322443439669248",
  },
  Leandro: {
    name: "Leandro",
    discordId: "994294354241933433",
  },
};

/**
 * Default sale owner auto-assigned to every new campaign.
 * Used as the ping target when no explicit owner is selected in the CMS.
 */
export const DEFAULT_SALE_OWNER: SaleOwnerName = "Leandro";

/**
 * List of sale owners for dropdown/select components.
 */
export const SALE_OWNERS_LIST: SaleOwner[] = Object.values(SALE_OWNERS);

/**
 * Mapping from HubSpot owner ID to Discord ID.
 * Only includes owners with a hubspotOwnerId configured.
 */
export const HUBSPOT_OWNER_ID_TO_DISCORD_ID: Record<string, string> = Object.fromEntries(
  SALE_OWNERS_LIST.filter((owner) => owner.hubspotOwnerId).map((owner) => [owner.hubspotOwnerId, owner.discordId]),
);
